import { render } from "./AboutArea.vue?vue&type=template&id=59f862d0"
import script from "./AboutArea.vue?vue&type=script&lang=js"
export * from "./AboutArea.vue?vue&type=script&lang=js"

import exportComponent from "/Users/frknalck/Desktop/MySite/GelisimPTurkiye/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__